import { Component, OnInit } from '@angular/core';
import moment from "moment";
import * as _ from 'lodash';
import { ChartData } from '../../../shared/charts/charts.model';
import { TransactionService } from '../../../transaction/transaction.service';
import { MomentJSHelper } from '../../../shared/utils/moment-js-helper';
import { TransactionsGroupedByAdvisor, TransactionAttribution } from '../../../transaction/transaction.model';
import { TransactionType } from 'common';

@Component({
    selector: 'ifb-residual-draws-card-chart',
    templateUrl: './residual-draws-card-chart.component.html',
    styleUrls: ['./residual-draws-card-chart.component.scss'],
    standalone: false
})
export class ResidualDrawsCardChartComponent implements OnInit {

  months: string[];
  currentMonth: string;

  chartData: ChartData = {
    view: [400, 330],
    options: {
      showXAxis: true,
      showYAxis: true,
      gradient: false,
      showLegend: false,
      showXAxisLabel: true,
      showYAxisLabel: false,
      colorScheme: {
        domain: ['#1c9b41']
      }
    }
  };

  constructor(private _transactionService: TransactionService) {
    this.currentMonth = moment().format('MMMM');
    this.months = MomentJSHelper.getActiveMonthsCurrentYear();
  }

  ngOnInit() {
    this.fetchData();
  }

  fetchData() {
    this._transactionService.groupedByAdvisor({
      fromDate: moment().month(this.currentMonth).startOf('month').format('L'),
      toDate: moment().month(this.currentMonth).endOf('month').format("L"),
      attribution: TransactionAttribution.Residual,
      type: [TransactionType.Draw]
    }).subscribe((data) =>
      this.chartData.data = _.map(data, function (item: TransactionsGroupedByAdvisor) {
        return { name: item.advisor ? item.advisor.fullName : '', value: item.totalAmount };
      }));
  }

  filterByMonth(value: string): void {
    this.currentMonth = value;
    this.fetchData();
  }

}
